import {
  PageHeader, IconButton,
} from '@components/2-molecules';
import { STATE } from '@lib/constants';
import { useCountry } from '@lib/hooks/useCountry';
import { useContact } from '@lib/hooks/useContact';
import * as utils from '@lib/utils';

import Sandwich from '@assets/icons/sandwich';
import Phonebook from '@assets/icons/book';

import { ForwardedPageProps } from '@lib/constants';



const ContactCreate: FC<ForwardedPageProps> = ({ navigation, data = {}, onDone, ...props }) => {

    const [contact, setContact] = useContact({data: data, operation: 'POST', state: STATE.CANCEL});

    const _onDone = (data: any) => { navigation.navigate('Contacts') };
    onDone = onDone || _onDone;
    utils.onStateChange(  contact, STATE.DONE, onDone);
    
    const saveContact= (): void => setContact({ ...contact, state: STATE.READY, message: 'Saving contact ...' });

    const updateData = (data: any): void => setContact((contact: any) => ({ ...contact, data: { ...contact.data, ...data } }));

    const [countries] = useCountry();

    const pageTitle = "CREATE / EDIT A NEW CONTACT";
    const pageBtn = "COMFIRM";

    return (
        <AppTemplate hooks={[countries, contact]}>
        
            <PageHeader title={pageTitle} left={<IconButton transparent icon={<Sandwich />} onPress={navigation?.toggleDrawer} />} />
            <Spacer h={1} />
            
            {/* Please, ignore for now and fix after next release
            <Card> 
                <Button xsmall height={33} align={"left"} bg={"#EEEEEE"} left={<Phonebook />} color={"#434BFF"}>
                    Import from Phonebook
                </Button>
            </Card>
            <Spacer h={2} /> */}

            <Card>

                <Input 
                    required
                    label={"Name"}
                    onChange={(value:any) => { updateData({ name: value }) }}
                    defaultValue={data.name} /><Spacer h={1.3} />

                 <Input 
                    label={"Phone"}
                    inputMode={"tel"}
                    autoCapitalize={"none"}
                    onChange={(value:any) => { updateData({ phone: value }) }}
                    defaultValue={data.phone} /><Spacer h={1.3} />

                <Input 
                    label={"Email"} 
                    inputMode={"email"}
                    autoComplete={"email"}
                    autoCapitalize={"none"}
                    onChange={(value:any) => { updateData({ email: value }) }}
                    defaultValue={data.email} /><Spacer h={1.3} />
                    
            </Card>

            <Spacer h={2} />
            <Card>
                <Input 
                    label={"Address"}
                    onChange={(value:any) => { updateData({ addressLine1: value }) }}
                    defaultValue={data.addressLine1} /><Spacer h={1.3} />

                <Input 
                    label={"City"}
                    onChange={(value:any) => { updateData({ addressLine2: value }) }}
                    defaultValue={data.addressLine2} /><Spacer h={1.3} />

                <Dropdown 
                    label={"Country"}
                    defaultValue={data.country}
                    onChange={(value: any) => { updateData({ countryId: value?.id, country: value }) }}
                    data={countries?.data} />
                    <Spacer h={1.3}/>
                    
            </Card>
            <Spacer h={2} />
            
            {/* <Card>
                <Input
                    label={"Due days"}
                    defaultValue={data.dueDays}
                    onChange={(value:any) => { updateData({ dueDays: value }) }}
                    />
                <Spacer h={1.3}/>
            </Card>
            <Spacer h={2} /> */}
            
            <Button  onPress={saveContact}>{pageBtn}</Button>
            <Spacer h={2} />

        </AppTemplate>
    );
};

import React, { FC } from 'react';

import {
    Card,
    Spacer,
} from '@components/1-atoms';

import {
    AppTemplate
} from '@components/4-templates';

import {
    Button,
    Dropdown,
    Input
} from '@components/2-molecules';

import { withForwardedNavigationParams } from 'react-navigation-props-mapper';
export default withForwardedNavigationParams<ForwardedPageProps>()(ContactCreate);